// extracted by mini-css-extract-plugin
export default {"content":"styleModule_content__PyOEB"};